import * as log from 'loglevel';
import {game} from '../GameCore';
import {playerSprite} from '../sprites/player/Player';
import {levelGroup} from '../level/Level';

var jumpEmittor: Phaser.Particles.Arcade.Emitter,
    landEmittor: Phaser.Particles.Arcade.Emitter,
    powerupGoodEmittor: Phaser.Particles.Arcade.Emitter,
    powerupBadEmittor: Phaser.Particles.Arcade.Emitter;


/**
 * create a number of particle emitters
 */
export function createParticles()
{
    //  jump emittor

    jumpEmittor = game.add.emitter(0, 0, 100);

    jumpEmittor.makeParticles('particles', Phaser.Animation.generateFrameNames('dust/dust-', 1, 4, '', 3));
    jumpEmittor.setAlpha(1, 0.2, 500, Phaser.Easing.Quadratic.Out);
    jumpEmittor.setScale(0.1, 0.6, 0.1, 0.6, 500, Phaser.Easing.Exponential.Out);
    jumpEmittor.minParticleSpeed.setTo(-300, -100);
    jumpEmittor.maxParticleSpeed.setTo(50, 10);
    jumpEmittor.gravity = -200;

    //  land emittor

    landEmittor = game.add.emitter(0, 0, 100);

    landEmittor.makeParticles('particles', Phaser.Animation.generateFrameNames('dust/dust-', 1, 4, '', 3));
    landEmittor.setAlpha(1, 0.3, 250, Phaser.Easing.Quadratic.Out);
    landEmittor.setScale(0.1, 0.6, 0.1, 0.6, 250, Phaser.Easing.Exponential.Out);
    landEmittor.minParticleSpeed.setTo(-250, -20);
    landEmittor.maxParticleSpeed.setTo(50, 10);
    landEmittor.gravity = -10;

    //  power-up good emittor

    powerupGoodEmittor = game.add.emitter(0, 0, 100);
    levelGroup.addChild(powerupGoodEmittor);

    powerupGoodEmittor.makeParticles('particles', 'powerup/good');
    powerupGoodEmittor.setAlpha(0.8, 0.1, 1500, Phaser.Easing.Exponential.Out);
    powerupGoodEmittor.minParticleScale = 0.15;
    powerupGoodEmittor.maxParticleScale = 2;
    powerupGoodEmittor.minParticleSpeed.setTo(-150, -150);
    powerupGoodEmittor.maxParticleSpeed.setTo(150, 150);
    powerupGoodEmittor.particleDrag = new Phaser.Point(30, 30);

    //  bad power-up

    powerupBadEmittor = game.add.emitter(0, 0, 100);
    levelGroup.addChild(powerupBadEmittor);

    powerupBadEmittor.makeParticles('particles', 'powerup/bad');
    powerupBadEmittor.setAlpha(0.8, 0.1, 1500, Phaser.Easing.Exponential.Out);
    powerupBadEmittor.minParticleScale = 0.1;
    powerupBadEmittor.maxParticleScale = 1;
    powerupBadEmittor.minParticleSpeed.setTo(-100, -100);
    powerupBadEmittor.maxParticleSpeed.setTo(100, 100);
    powerupBadEmittor.particleDrag = new Phaser.Point(30, 30);
    powerupBadEmittor.gravity = 50;
}


/**
 * explode some dust particles when the player jumps
 * @param x
 * @param y
 */
export function addJumpParticles(x: number, y: number)
{
    //  Position the emitter where the mouse/touch event was

    jumpEmittor.x = x;
    jumpEmittor.y = y;

    //  The first parameter sets the effect to "explode" which means all particles are emitted at once
    //  The second gives each particle a 2000ms lifespan
    //  The third is ignored when using burst/explode mode
    //  The final parameter (10) is how many particles will be emitted in this single burst

    jumpEmittor.start(true, 500, null, 8);
}



/**
 * explode some dust particles when the player jumps
 * @param x
 * @param y
 */
export function addLandParticles(x: number, y: number)
{
    //  Position the emitter where the mouse/touch event was

    landEmittor.x = x;
    landEmittor.y = y;

    //  The first parameter sets the effect to "explode" which means all particles are emitted at once
    //  The second gives each particle a 2000ms lifespan
    //  The third is ignored when using burst/explode mode
    //  The final parameter (10) is how many particles will be emitted in this single burst

    landEmittor.start(true, 500, null, 5);
}



/**
 * explode some dust particles when the player jumps
 * @param x
 * @param y
 */
export function addPowerupGoodParticles(x: number, y: number)
{
    //  Position the emitter where the mouse/touch event was

    powerupGoodEmittor.x = x;
    powerupGoodEmittor.y = y;

    powerupGoodEmittor.start(true, 500, null, 20);
}



/**
 * explode some dust particles when the player jumps
 * @param x
 * @param y
 */
export function addPowerupBadParticles(x: number, y: number)
{
    //  Position the emitter where the mouse/touch event was

    powerupBadEmittor.x = x;
    powerupBadEmittor.y = y;

    powerupBadEmittor.start(true, 1000, null, 50);
}


// WEBPACK FOOTER //
// ./src/ts/game/particles/ParticleManager.ts